import React from 'react'
import { Section } from '@shared/components/section'

import { socials } from './data'

import styles from './style.module.scss'

export const View = () => {
	return (
		<Section fullWidth className={styles.wrap}>
			<div className={styles.socials}>
				<h4 className={styles.title}>Делимся полезными материалами</h4>
				<div className={styles.socialsContent}>
					{socials.map((social) => (
						<a
							href={social.href}
							key={social.href}
							className={styles.socialLink}
							target='_blank'
							rel='noopener noreferrer nofollow'
						>
							<social.IconComponent className={styles.socialSvg} />
							{social.title} &#8594;
						</a>
					))}
				</div>
			</div>
		</Section>
	)
}
